export default "__VITE_ASSET__DvucpwXc__"